<template>
	<div class="w-100" :class="{
		'fixed-top': fixed && fixed_position == 'top',
		'fixed-bottom': fixed && fixed_position == 'bottom'
	}" :style="space_fixed">
		<b-row class="justify-content-center" no-gutters>
		  <b-col cols="12" sm="8" md="6" lg="4" xl="4">
		  	<slot></slot>
		  </b-col>
		</b-row>
	</div>
</template>
<script>
	export default{
		props: {
			fixed:{
				type: Boolean,
				default: true
			},
			fixed_position:{
				type: String,
				default: 'top'
			},
			space:{
				type: Number,
				default: 0
			},
			z_index:{
				type:Number,
				default: 1028
			}
		},
		computed:{
			space_fixed(){
				let return_data = {
					zIndex: `${this.z_index} !important`
				}
				if(this.fixed_position == 'top'){
					return_data.top = `${this.space}px`
				}else{
					return_data.bottom = `${this.space}px`
				}
				return return_data
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/WrapperMobileView.vue